import React from "react";
import { Grid, TextField } from "@mui/material";
import { fieldSx } from "./bottleOrderFormHelpers";

const CoolerStep = ({ formData, handleChange }) => (
    <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
            <TextField fullWidth size="small" variant="outlined" label="Cooler Number"
                value={formData.coolerNumber} onChange={handleChange("coolerNumber")} sx={fieldSx} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
            <TextField fullWidth size="small" variant="outlined" label="Cooler Status"
                value={formData.coolerStatus} onChange={handleChange("coolerStatus")} sx={fieldSx} />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
            <TextField fullWidth size="small" variant="outlined" label="Date Received" type="date"
                value={formData.dateReceivedCooler} onChange={handleChange("dateReceivedCooler")}
                InputLabelProps={{ shrink: true }} sx={fieldSx} />
        </Grid>
    </Grid>
);

export default CoolerStep;
